import React, { FC } from 'react';

import { Box, Check24, Stack, StopSign24, Telegram24, Typography } from 'Modules/ui3';
import { useTranslation } from 'Modules/core/i18n';

import { ConfimationMessageProps, TELEGRAM_LINK } from './types';


export const ConfimationMessage: FC<ConfimationMessageProps> = ({
    success,
    needForTG = true,
    wrapperSx,
    mainBlockSx,
    secondaryTextSx,
    messageTranslation,
    customErrorHelper,
}) => {
    const { t } = useTranslation(messageTranslation);

    return (
        <Stack
            width='480px'
            minHeight='332px'
            justifyContent='center'
            p={8}
            data-testid='modal-success'
            sx={wrapperSx}
        >
            <Stack
                alignItems='center'
                sx={mainBlockSx}
            >
                <Box
                    borderRadius={25}
                    bgcolor={`infoCustom.${success ? 'green10' : 'red10'}`}
                    p={4}
                    lineHeight={0}
                >
                    <Box
                        borderRadius={25}
                        bgcolor={`infoCustom.${success ? 'green50' : 'red50'}`}
                        color='grayscale.shade0'
                        p={4}
                        sx={{
                            '& > svg': {
                                fontSize: ({ spacing }) => spacing(8),
                            },
                        }}
                    >
                        {success ? <Check24 /> : <StopSign24 />}
                    </Box>
                </Box>

                <Typography component='h3' variant='boldTitle5' color='grayscale.shade95' mt={4}>
                    {t(success ? 'success.title' : 'error.title')}
                </Typography>

                <Typography
                    component='p'
                    variant='regularCaption1'
                    color='grayscale.shade90'
                    mt={2}
                    textAlign='center'
                    sx={secondaryTextSx}
                >
                    {success ? t('success.helper') : customErrorHelper ?? t('error.helper')}
                </Typography>
                {needForTG && success && (
                    <Stack
                        component='a'
                        href={TELEGRAM_LINK}
                        target='_blank'
                        rel='noopener noreferrer'
                        direction='row'
                        alignItems='center'
                        spacing={4}
                        p={2}
                        mt={8}
                        bgcolor='grayscale.shade5'
                        borderRadius={25}
                    >
                        <Telegram24 sx={{ fontSize: ({ spacing }) => spacing(8) }} />
                        <Typography variant='regularCaption1' color='grayscale.shade90'>
                            {t('telegram')}
                        </Typography>
                    </Stack>
                )}
            </Stack>
        </Stack>
    );
};
